//@NOTE This component is an exact copy and paste of the original component from the Highcharts library here: https://git.hubteam.com/HubSpot/ui-addon-infra/blob/ff693640f459b113f17fd6f0192a1ce24413a295/ui-addon-infra/static/js/highcharts/ReactHighchart/index.tsx#L1
import { createRef, createElement, PureComponent } from 'react';
import Highcharts from 'highcharts';
import getChartOptions from './ChartOptions';
import { withTheme } from 'foundations-theming/utils';
// based on https://github.com/highcharts/highcharts-react
class ReactHighchart extends PureComponent {
  constructor(...args) {
    super(...args);
    this.chart = null;
    this.container = /*#__PURE__*/createRef();
    this.resizeObserver = new ResizeObserver(() => {
      if (this.chart) {
        this.chart.reflow();
      }
    });
  } // Use ResizeObserver so that the chart also reflows when
  // the container dimensions change because of DOM updates
  // and not just window resize events
  componentDidMount() {
    Highcharts.setOptions(getChartOptions(this.props.theme));
    this.createChart();
    if (this.container.current) {
      this.resizeObserver.observe(this.container.current);
    }
  }
  componentDidUpdate() {
    const {
      options
    } = this.props;
    this.chart.update(options, true, true);
  }
  componentWillUnmount() {
    // Destroy chart
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.resizeObserver.disconnect();
  }
  createChart() {
    const {
      options,
      callback
    } = this.props;
    if (!options) {
      console.warn('The "options" property was not passed.');
    } else if (this.container.current) {
      // Create a chart
      this.chart = Highcharts.chart(this.container.current, options, callback);
    }
  }
  render() {
    // Create container for the chart
    return /*#__PURE__*/createElement('div', Object.assign({}, this.props.containerProps, {
      ref: this.container
    }));
  }
}
export default withTheme(ReactHighchart);
export const WEBPACK_3_FORCE_MODULE_IMPORT = 1;